import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import { SaveAsExcelFileParams } from '../types/excel';

const EXCEL_TYPE =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

export const useExcel = () => {
    const saveAsExcelFile = ({ buffer, fileName }: SaveAsExcelFileParams) => {
        const data: Blob = new Blob([buffer], {
            type: EXCEL_TYPE,
        });
        saveAs(data, fileName + '_export' + EXCEL_EXTENSION);
    };

    const exportAsExcelFile = (json: Object[], excelFileName: string) => {
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
        const workbook: XLSX.WorkBook = {
            Sheets: { data: worksheet },
            SheetNames: ['data'],
        };
        const excelBuffer: any = XLSX.write(workbook, {
            bookType: 'xlsx',
            type: 'array',
        });
        saveAsExcelFile({ buffer: excelBuffer, fileName: excelFileName });
    };

    return { exportAsExcelFile };
};
